import { createFileRoute, Link } from '@tanstack/react-router'
import { LayoutGrid, Sparkles } from 'lucide-react'
import { AppHeader } from '#/components/layout/app-header'
import { Button } from '#/components/ui/button'
import { WorkspaceCanvas } from '#/components/workspace/workspace-canvas'
import { WorkspaceName } from '#/components/workspace/workspace-name'
import { useWorkspacePlans } from '#/lib/api'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/workspace/$workspaceId/')({ component: WorkspaceHome })

function WorkspaceHome() {
  const { workspaceId } = Route.useParams()
  const { data, error } = useWorkspacePlans(workspaceId)
  return (
    <>
      <AppHeader
        showStats={false}
        left={data ? <WorkspaceName id={workspaceId} name={data.workspace.name} /> : null}
        right={
          <div className="flex items-center gap-1">
            <Button asChild size="sm" variant="ghost" className="h-8 gap-1.5">
              <Link to="/workspace/$workspaceId/room" params={{ workspaceId }}><LayoutGrid className="size-4" /> <span className="hidden sm:inline">{m.rm_nav()}</span></Link>
            </Button>
            {data?.canCreatePlan ? (
              <Button asChild size="sm" className="h-8 gap-1.5">
                <Link to="/plan" search={{ flow: 'new', workspace: workspaceId }}><Sparkles className="size-4" /> <span className="hidden sm:inline">{m.ws_new_plan()}</span></Link>
              </Button>
            ) : null}
          </div>
        }
      />
      <main className="flex-1 overflow-hidden">
        {error ? <p className="p-8 text-destructive">{(error as Error).message}</p> : data ? <WorkspaceCanvas data={data} /> : <div className="p-8 text-muted-foreground">{m.common_loading()}</div>}
      </main>
    </>
  )
}
